'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  (0, _classCallCheck3.default)(this, _class);

  var expanded = false;

  if (el.dataset.dropdownEnabled === 'true') {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      var itemToExpand = e.target;

      expanded = itemToExpand.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        itemToExpand.setAttribute('aria-expanded', 'false');
      } else {
        itemToExpand.setAttribute('aria-expanded', 'true');
      }
    });
  }
};

exports.default = _class;